import { useState, useEffect } from "react";
import { getUsers, createUser, updateUser, deleteUser, changePassword } from "@/lib/api";
import api from "@/lib/api";
import { useAuth, GESTIONI_META } from "@/lib/AuthContext";

export default function UtentiPage() {
  const { user: currentUser } = useAuth();
  const [users, setUsers] = useState([]);
  const [pending, setPending] = useState([]);
  const [approving, setApproving] = useState(null); // user being approved
  const [approveForm, setApproveForm] = useState({ role: "user", gestioni: {}, user_type: "utente" });
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ username: "", name: "", password: "", role: "user", gestioni: {} });
  const [msg, setMsg] = useState(null);
  const [showPwd, setShowPwd] = useState(false);
  const [pwdForm, setPwdForm] = useState({ old_password: "", new_password: "" });
  const [pwdMsg, setPwdMsg] = useState(null);
  const [notifyEmail, setNotifyEmail] = useState(currentUser?.notify_email || currentUser?.email || "");
  const [notifyMsg, setNotifyMsg] = useState(null);

  useEffect(() => {
    setNotifyEmail(currentUser?.notify_email || currentUser?.email || "");
  }, [currentUser]);

  const fetchUsers = async () => {
    setLoading(true);
    try { const res = await getUsers(); setUsers(res.data.data); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  };
  const fetchPending = async () => {
    try { const res = await api.get("/admin/pending-users"); setPending(res.data.data || []); }
    catch (e) { console.error(e); }
  };
  useEffect(() => { fetchUsers(); fetchPending(); }, []);

  const openApprove = (u) => {
    setApproving(u);
    setApproveForm({ role: "user", gestioni: {}, user_type: "utente" });
  };
  const closeApprove = () => { setApproving(null); };
  const toggleApproveGestione = (k) => {
    setApproveForm(f => ({ ...f, gestioni: { ...f.gestioni, [k]: !f.gestioni[k] } }));
  };
  const doApprove = async () => {
    try {
      await api.post(`/admin/pending-users/${approving._id}/approve`, approveForm);
      setMsg({ ok: true, text: `Utente ${approving.email} approvato` });
      closeApprove();
      fetchUsers(); fetchPending();
    } catch (e) { setMsg({ ok: false, text: e.response?.data?.detail || "Errore" }); }
  };
  const doReject = async (u) => {
    if (!window.confirm(`Rifiutare l'accesso a ${u.email}?`)) return;
    try {
      await api.post(`/admin/pending-users/${u._id}/reject`);
      setMsg({ ok: true, text: `Utente ${u.email} rifiutato` });
      fetchPending();
    } catch (e) { setMsg({ ok: false, text: e.response?.data?.detail || "Errore" }); }
  };

  const resetForm = () => { setForm({ username: "", name: "", password: "", role: "user", gestioni: {} }); setEditId(null); setShowForm(false); };

  const handleEdit = (u) => {
    setEditId(u._id);
    setForm({ username: u.username, name: u.name || "", password: "", role: u.role || "user", gestioni: u.gestioni || {} });
    setShowForm(true);
    setMsg(null);
  };

  const handleSave = async () => {
    setMsg(null);
    try {
      if (editId) {
        const data = { name: form.name, role: form.role, gestioni: form.gestioni };
        if (form.password) data.password = form.password;
        await updateUser(editId, data);
        setMsg({ ok: true, text: "Utente aggiornato" });
      } else {
        if (!form.username || !form.password) { setMsg({ ok: false, text: "Username e password obbligatori" }); return; }
        await createUser(form);
        setMsg({ ok: true, text: "Utente creato" });
      }
      resetForm(); fetchUsers();
    } catch (e) {
      setMsg({ ok: false, text: e.response?.data?.detail || "Errore" });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Eliminare questo utente?")) return;
    try { await deleteUser(id); fetchUsers(); setMsg({ ok: true, text: "Utente eliminato" }); }
    catch (e) { setMsg({ ok: false, text: e.response?.data?.detail || "Errore" }); }
  };

  const handleChangePwd = async () => {
    setPwdMsg(null);
    try {
      await changePassword(pwdForm.old_password, pwdForm.new_password);
      setPwdMsg({ ok: true, text: "Password cambiata con successo" });
      setPwdForm({ old_password: "", new_password: "" });
    } catch (e) { setPwdMsg({ ok: false, text: e.response?.data?.detail || "Errore" }); }
  };

  const saveNotifyEmail = async () => {
    setNotifyMsg(null);
    try {
      await api.put("/auth/me/notify-email", { notify_email: notifyEmail });
      setNotifyMsg({ ok: true, text: "Email di notifica salvata" });
    } catch (e) { setNotifyMsg({ ok: false, text: e.response?.data?.detail || "Errore" }); }
  };

  const toggleGestione = (key) => {
    setForm(f => ({ ...f, gestioni: { ...f.gestioni, [key]: !f.gestioni[key] } }));
  };

  return (
    <div data-testid="utenti-page">
      <div className="sw-page-title"><h1>Gestione Utenti</h1><div className="sw-breadcrumb">Home &gt; Utenti</div></div>

      {/* Cambia Password */}
      <div className="sw-card" style={{ marginBottom: 0 }}>
        <div className="sw-card-header" style={{ cursor: "pointer" }} onClick={() => setShowPwd(!showPwd)}>
          Cambia la mia Password {showPwd ? "▲" : "▼"}
        </div>
        {showPwd && (
          <div className="sw-card-body">
            <div className="sw-filter-row">
              <span className="sw-filter-label">Password attuale:</span>
              <input type="password" value={pwdForm.old_password} onChange={e => setPwdForm({ ...pwdForm, old_password: e.target.value })} className="sw-filter-input" style={{ width: 250 }} />
              <span className="sw-filter-label">Nuova password:</span>
              <input type="password" value={pwdForm.new_password} onChange={e => setPwdForm({ ...pwdForm, new_password: e.target.value })} className="sw-filter-input" style={{ width: 250 }} />
              <button className="sw-filter-btn sw-filter-btn-primary" onClick={handleChangePwd}>Cambia</button>
              {pwdMsg && <span style={{ fontSize: 12, fontWeight: 600, color: pwdMsg.ok ? "#006600" : "#cc0000" }}>{pwdMsg.text}</span>}
            </div>
          </div>
        )}
      </div>

      {msg && <div style={{ margin: "12px 20px", padding: "8px 12px", background: msg.ok ? "#eeffee" : "#ffeeee", border: `1px solid ${msg.ok ? "#aea" : "#eaa"}`, fontSize: 12, fontWeight: 600, color: msg.ok ? "#060" : "#c00" }}>{msg.text}</div>}

      {/* Richieste in attesa (Google OAuth) */}
      {pending.length > 0 && (
        <div className="sw-card" data-testid="pending-requests-card" style={{ margin: "12px 20px", border: "2px solid #ff9800" }}>
          <div className="sw-card-header" style={{ background: "#fff3e0", color: "#e65100", display: "flex", alignItems: "center", gap: 8 }}>
            <span>⏳ Richieste di accesso in attesa</span>
            <span style={{ background: "#ff6f00", color: "white", borderRadius: 10, padding: "1px 8px", fontSize: 11 }}>{pending.length}</span>
          </div>
          <div className="sw-card-body" style={{ padding: 0 }}>
            <table className="sw-table">
              <thead>
                <tr>
                  <th style={{ width: 36 }}>#</th>
                  <th>Email</th>
                  <th>Nome</th>
                  <th>Data richiesta</th>
                  <th style={{ width: 180 }}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {pending.map((p, i) => (
                  <tr key={p._id}>
                    <td className="center-col" style={{ color: "#888" }}>{i + 1}</td>
                    <td>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {p.photo_url && <img src={p.photo_url} alt="" style={{ width: 24, height: 24, borderRadius: "50%" }} />}
                        <b>{p.email}</b>
                      </div>
                    </td>
                    <td>{p.name || "-"}</td>
                    <td style={{ fontSize: 11, color: "#666" }}>{p.created_at ? new Date(p.created_at).toLocaleString("it-IT") : "-"}</td>
                    <td>
                      <button data-testid={`btn-approve-${p._id}`} onClick={() => openApprove(p)} style={{ background: "#2e7d32", color: "white", border: "none", padding: "4px 10px", fontSize: 11, fontWeight: 600, cursor: "pointer", marginRight: 6 }}>✓ Approva</button>
                      <button data-testid={`btn-reject-${p._id}`} onClick={() => doReject(p)} style={{ background: "white", color: "#c62828", border: "1px solid #c62828", padding: "4px 10px", fontSize: 11, fontWeight: 600, cursor: "pointer" }}>✕ Rifiuta</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Popup approvazione */}
      {approving && (
        <div onClick={closeApprove} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 500, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div onClick={e => e.stopPropagation()} data-testid="approve-modal" style={{ background: "white", width: "100%", maxWidth: 520, borderRadius: 4, overflow: "hidden" }}>
            <div style={{ background: "#2e7d32", color: "white", padding: "12px 16px", display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 700 }}>Approva utente: {approving.email}</span>
              <button onClick={closeApprove} style={{ background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: 20 }}>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#666", marginBottom: 4 }}>Tipo utente</label>
                <select data-testid="approve-user-type" value={approveForm.user_type} onChange={e => setApproveForm(f => ({ ...f, user_type: e.target.value }))} className="sw-filter-select" style={{ width: "100%" }}>
                  <option value="utente">Utente (personale, staff)</option>
                  <option value="alunno">Alunno</option>
                  <option value="operatore">Operatore</option>
                </select>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#666", marginBottom: 4 }}>Ruolo</label>
                <select data-testid="approve-role" value={approveForm.role} onChange={e => setApproveForm(f => ({ ...f, role: e.target.value }))} className="sw-filter-select" style={{ width: "100%" }}>
                  <option value="user">Utente standard</option>
                  <option value="admin">Amministratore</option>
                </select>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#666", marginBottom: 4 }}>Gestioni accessibili</label>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {GESTIONI_META.map(g => (
                    <label key={g.key} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer", padding: "6px 12px", border: `1px solid ${approveForm.gestioni[g.key] ? g.color : "#ccc"}`, borderRadius: 2, background: approveForm.gestioni[g.key] ? "#e8f0fe" : "white", fontWeight: 600 }}>
                      <input type="checkbox" checked={!!approveForm.gestioni[g.key]} onChange={() => toggleApproveGestione(g.key)} />
                      {g.label}
                    </label>
                  ))}
                </div>
              </div>
              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
                <button onClick={closeApprove} className="sw-filter-btn">Annulla</button>
                <button data-testid="btn-confirm-approve" onClick={doApprove} className="sw-filter-btn sw-filter-btn-primary">✓ Conferma approvazione</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div style={{ margin: "12px 20px 4px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 12, color: "#666" }}>{users.length} utenti</span>
        <button className="sw-filter-btn sw-filter-btn-primary" onClick={() => { resetForm(); setShowForm(true); setMsg(null); }} data-testid="btn-new-user">+ Nuovo Utente</button>
      </div>

      <div className="sw-table-container" style={{ overflowX: "auto" }}>
        <table className="sw-table sw-table-compact" style={{ fontSize: 11, tableLayout: "auto" }}>
          <thead>
            <tr>
              <th style={{ width: 32, textAlign: "center", padding: "4px 4px" }}>#</th>
              <th style={{ minWidth: 110, padding: "4px 6px" }}>Username</th>
              <th style={{ minWidth: 130, padding: "4px 6px" }}>Nome</th>
              <th style={{ width: 50, textAlign: "center", padding: "4px 4px" }}>Ruolo</th>
              {GESTIONI_META.map(g => (
                <th key={g.key} className="center-col" title={g.label}
                    style={{ width: 36, padding: "4px 2px", textAlign: "center", borderLeft: "1px solid rgba(255,255,255,0.15)" }}>
                  <div style={{ fontSize: 14, lineHeight: 1 }}>{g.icon}</div>
                  <div style={{ fontSize: 8, fontWeight: 700, color: g.color, marginTop: 2 }}>{g.short}</div>
                </th>
              ))}
              <th style={{ width: 110, textAlign: "center", padding: "4px 6px" }}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={4 + GESTIONI_META.length + 1} className="sw-loading">Caricamento...</td></tr>
            : users.map((u, i) => (
              <tr key={u._id}>
                <td className="center-col" style={{ color: "#888", padding: "2px 4px", fontFamily: "Consolas, monospace" }}>{i + 1}</td>
                <td style={{ fontWeight: 600, padding: "2px 6px" }}>{u.username}</td>
                <td style={{ padding: "2px 6px", color: u.name ? "#333" : "#bbb" }}>{u.name || "—"}</td>
                <td style={{ textAlign: "center", padding: "2px 4px" }}>
                  <span title={u.role}
                    style={{ display: "inline-block", width: 18, height: 18, lineHeight: "18px", borderRadius: "50%",
                             background: u.role === "admin" ? "#0066cc" : "#cfd8dc",
                             color: u.role === "admin" ? "white" : "#37474f",
                             fontSize: 10, fontWeight: 700 }}>
                    {u.role === "admin" ? "A" : "U"}
                  </span>
                </td>
                {GESTIONI_META.map(g => {
                  const ok = u.role === "admin" || !!u.gestioni?.[g.key];
                  return (
                    <td key={g.key} className="center-col"
                        title={`${g.label}: ${ok ? "abilitata" : "non abilitata"}`}
                        style={{ padding: "2px 2px", borderLeft: "1px solid #eee", background: ok ? `${g.color}1a` : undefined }}>
                      {ok
                        ? <span style={{ display: "inline-block", width: 14, height: 14, lineHeight: "14px", borderRadius: "50%", background: g.color, color: "white", fontSize: 9, fontWeight: 700 }}>✓</span>
                        : <span style={{ color: "#dcdcdc", fontSize: 11 }}>·</span>}
                    </td>
                  );
                })}
                <td style={{ textAlign: "center", padding: "2px 6px", whiteSpace: "nowrap" }}>
                  <button onClick={() => handleEdit(u)} data-testid={`btn-edit-${u.username}`}
                    style={{ border: "1px solid #0066cc", background: "white", color: "#0066cc", cursor: "pointer", fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 2 }}>
                    ✎ Modifica
                  </button>
                  {u.user_type === "alunno" && (
                    <button
                      data-testid={`btn-toggle-test-${u.username}`}
                      onClick={async () => {
                        const next = !u.is_test_user;
                        if (!window.confirm(next
                          ? `Marcare "${u.username}" come UTENTE DI PROVA?\n\nPotrà accedere al Portale Alunni Extra e SPOT anche quando i portali sono chiusi.`
                          : `Rimuovere il flag "Utente di prova" da "${u.username}"?`)) return;
                        try {
                          await api.put(`/users/${u._id}/is-test-user`, { is_test_user: next });
                          fetchUsers();
                        } catch (e) {
                          alert("Errore: " + (e.response?.data?.detail || e.message));
                        }
                      }}
                      title={u.is_test_user ? "Utente di PROVA: bypassa la chiusura portale. Clicca per rimuovere." : "Marca come utente di prova (bypassa portale chiuso)"}
                      style={{ border: `1px solid ${u.is_test_user ? "#ef6c00" : "#999"}`,
                               background: u.is_test_user ? "#ef6c00" : "white",
                               color: u.is_test_user ? "white" : "#999",
                               cursor: "pointer", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 2, marginLeft: 4 }}>
                      🧪 {u.is_test_user ? "PROVA" : "prova"}
                    </button>
                  )}
                  {u._id !== currentUser?._id && u.role !== "admin" && (
                    <button onClick={() => handleDelete(u._id)}
                      title="Elimina utente"
                      style={{ border: "1px solid #c62828", background: "white", color: "#c62828", cursor: "pointer", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 2, marginLeft: 4 }}>
                      🗑
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div className="sw-card">
          <div className="sw-card-header">{editId ? "Modifica Utente" : "Nuovo Utente"}</div>
          <div className="sw-card-body">
            <div className="sw-filter-row" style={{ marginBottom: 8 }}>
              <span className="sw-filter-label" style={{ width: 100 }}>Username:</span>
              <input type="text" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} className="sw-filter-input" style={{ width: 200 }} disabled={!!editId} data-testid="form-username" />
            </div>
            <div className="sw-filter-row" style={{ marginBottom: 8 }}>
              <span className="sw-filter-label" style={{ width: 100 }}>Nome:</span>
              <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="sw-filter-input" style={{ width: 200 }} data-testid="form-name" />
            </div>
            <div className="sw-filter-row" style={{ marginBottom: 8 }}>
              <span className="sw-filter-label" style={{ width: 100 }}>Password:</span>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="sw-filter-input" style={{ width: 200 }} placeholder={editId ? "lascia vuoto per non cambiare" : ""} data-testid="form-password" />
            </div>
            <div className="sw-filter-row" style={{ marginBottom: 8 }}>
              <span className="sw-filter-label" style={{ width: 100 }}>Ruolo:</span>
              <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} className="sw-filter-select" data-testid="form-role">
                <option value="user">Utente</option>
                <option value="admin">Amministratore</option>
              </select>
            </div>
            {form.role !== "admin" && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, color: "#333" }}>Gestioni abilitate:</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {GESTIONI_META.map(g => (
                    <label key={g.key} data-testid={`form-gestione-${g.key}`} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer", padding: "6px 12px", border: `1px solid ${form.gestioni[g.key] ? g.color : "#ccc"}`, borderRadius: 2, background: form.gestioni[g.key] ? "#e8f0fe" : "white", fontWeight: 600 }}>
                      <input type="checkbox" checked={!!form.gestioni[g.key]} onChange={() => toggleGestione(g.key)} />
                      <span style={{ color: g.color }}>{g.icon}</span> {g.label}
                    </label>
                  ))}
                </div>
              </div>
            )}
            <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
              <button className="sw-filter-btn sw-filter-btn-primary" onClick={handleSave} data-testid="btn-save-user">Salva</button>
              <button className="sw-filter-btn" onClick={resetForm}>Annulla</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
